import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export const deleteUser = async (userId) => {
  const token = localStorage.getItem("minebikers_token");

  if (!token || !userId) {
    console.log("Token puuttuu");
    return false;
  }
  try {
    const response = await makeCSRFRequest(
      `${BASE_URL}/vieraskirja/user/${userId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Failed to delete user");
    }
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
